<template>
	<c-dialog ref="dialog" title="退货单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.return_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.return_code}}</label>
			</div>
		</template>

		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="退货单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="客户名称">
						{{detailData.customer_name}}
					</c-detail-item>
					<c-detail-item label="退货仓库">
						{{detailData.warehouse_name}}
					</c-detail-item>
					<c-detail-item label="退货数量">
						{{detailData.return_count}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间" colspan="2">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item v-if="detailData.orders" label="关联销售单">
						<order-link type="order" :data="detailData.orders"></order-link>
					</c-detail-item>
					<custom-detail work-type="53" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="退货明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="returnTable" view-id="20026" height="grow" readonly></custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'orderReturnDetail',

		props: {
			id: [String, Number]
		},

		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/order/return/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.returnTable.init();
						this.$refs.returnTable.$refs.list.setData(data.productList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
